import React from 'react';
import GlobalBreadcrumbs from '../../components/global/GlobalBreadcrumbs';
import WrapperSection from '../../components/global/WrapperSection';
import FormAddEditGuardian from '../../components/guardians/FormAddEditGuardian';
const CreateGuardian = () => (<WrapperSection><GlobalBreadcrumbs /><FormAddEditGuardian /></WrapperSection>);
export default CreateGuardian;
